module.exports = __webpack_public_path__ + "img/iphone_4.06304422.png";